import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';

import {DtToolbarComponent} from './dt-toolbar.component';
import {DtColumnTogglerModule} from '../dt-column-toggler';
import { DropdownModule } from '../dropdown';

//https://stackoverflow.com/questions/35159079/is-it-possible-to-use-a-pipe-in-the-code
import { TitlePipe } from '../pipes';

import { PdfViewerNg2Module } from 'src/app/popups/custom/pdf-viewer-ng2';
//import { PdfViewerNg2Component } from 'src/app/popups/custom/pdf-viewer-ng2/pdf-viewer-ng2.component';

@NgModule({
  imports: [
    CommonModule,
    DtColumnTogglerModule,
    DropdownModule,

    PdfViewerNg2Module,
  ],
  declarations: [
    DtToolbarComponent,

    //PdfViewerNg2Component,
  ],
  exports: [
    DtToolbarComponent,
  ],
  providers: [
    TitlePipe,
  ]
})
export class DtToolbarModule {}
